<script>
import EnvironmentUtils from '@/utils/environmentUtils'

export default
{
    name: 'phone-notif-preview',

    props:
    {
        title: { type: String, required: true },
        content: { type: String, required: true },
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='phone-notif-preview'>
                <inline-svg class='mockup' src={require('@/assets/img/iphone-wireframe.svg')} on-loaded={this.resizeMockupWireframe} />
                <div class='content'>
                    <span class='time'>{ new Intl.DateTimeFormat('fr-FR', { hour: 'numeric', minute: 'numeric' }).format(new Date()) }</span>
                    <span class='date'>{ new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }).format(new Date()) }</span>
                    <div class='notif-container'>
                        <div class='header'>
                            <div class='app-info'>
                                <img class='app-icon' src={require('~/static/favicon.png')} />
                                <span class='app-name'>{ EnvironmentUtils.cityName }</span>
                            </div>
                            <span class='time-arrived'>maintenant</span>
                        </div>
                        <div class='title'>{ this.title }</div>
                        <div class='content'>{ this.content }</div>
                    </div>
                </div>
            </div>
        )
    },

    mounted ()
    {
        window.addEventListener('resize', this.resizeMockupWireframe)
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    beforeDestroy ()
    {
        window.removeEventListener('resize', this.resizeMockupWireframe)
    },

    methods:
    {
        resizeMockupWireframe ()
        {
            this.$nextTick(() =>
            {
                if (!this.$el) return
                const mockup = this.$el.querySelector('.mockup')
                if (!mockup) return

                mockup.style.width = this.$el.getBoundingClientRect().width + 'px'
            })
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.phone-notif-preview
{
    > .mockup
    {
        position: absolute;
        width: calc(100% - 20px);
        height: inherit;
    }

    > .content
    {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        top: 100px;

        .OnTablet({
            width: 38vw;
            margin-left: 1vw;
        });

        .OnDesktop({
            width: 35vw;
            margin-left: 0;
        });

        .OnLarge({ width: 30vw; });

        .OnLarge({ top: 170px });
        

        > .time
        {
            font-weight: lighter;
            color: var(--theme-background-text-color-soft);
            font-size: 300%;

            .OnDesktop({ font-size: 380%; });
            .OnLarge({ font-size: 570%; });
        }

        > .date
        {
            font-weight: lighter;
            color: var(--theme-background-text-color-soft);
            font-size: 120%;

            .OnDesktop({ font-size: 140%; });
            .OnLarge({ font-size: 240%; });
        }

        > .notif-container
        {
            display: flex;
            flex-direction: column;
            background-color: var(--theme-background-text-color-extra-light);
            padding: 15px 12px;
            border-radius: 13px;
            box-shadow: 0 0 2px 0px #0000000d;
            font-size: 80%;
            margin-top: 5vw;
            width: 77%;

            .OnDesktop({ margin-top: 2.5vw; });
            .OnTablet({ font-size: 60%; });
            .OnDesktop({ font-size: 75%; });
            .OnLarge({
                font-size: 100%;
                width: 80%;
            });
            
            > .header
            {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                color: var(--theme-background-text-color);

                > .app-info
                {
                    > .app-icon
                    {
                        vertical-align: text-bottom;
                        margin-right: 7px;
                        width: 15px;
                        height: 15px;

                        .OnTablet({
                            width: 12px;
                            height: 12px;
                        });

                        .OnLarge({
                            width: 20px;
                            height: 20px;
                            margin-right: 11px;
                        });
                    }

                    > .app-name
                    {
                        text-transform: uppercase;
                    }
                }
            }

            > .title
            {
                font-weight: bold;
                margin-top: 10px;

                .OnLarge({ margin-top: 15px; });
            }

            > .content
            {
                margin-top: 3px;
                line-break: anywhere;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/PhoneNotifPreview.vue